import { Flex } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { Action, Pages, SecondaryLayoutData } from "~/core";
import type { GetSettingsQuery as GetSettingsQuerySdk } from "~/core/sdk";
import { BottomLogos } from "~/features/secondary-footer/components/BottomLogos";
import { FooterBottomButtons } from "~/features/secondary-footer/components/FooterBottomButtons";
import { FooterDescription } from "~/features/secondary-footer/components/FooterDescription";
import { FooterLogoAndLanguageSelect } from "~/features/secondary-footer/components/FooterLogoAndLanguageSelect";
import { FooterMenu } from "~/features/secondary-footer/components/FooterMenu";
import { PaymentFeature } from "~/features/secondary-footer/components/PaymentFeature";

/**
 *   Footer для Secondary Layout заполняется из коллекции secondary_layout
 */
export type SecondaryFooterData = SecondaryLayoutData & {
  language: string;
  availableLanguages: Array<string>;
  languages: GetSettingsQuerySdk["languages"];
};
export type SecondaryFooterProps = {
  data: SecondaryFooterData;
  onCallAction: (action: Action) => void;
  isActionInactive: (control: Action) => boolean;
  getUrl: (page: Pages) => string;
};
export const SecondaryFooter: FC<SecondaryFooterProps> = (props) => {
  const { data, isActionInactive, onCallAction, getUrl } = props;
  const isPaymentFeatureEnabled = data?.payment_feature_enabled ?? true;

  return (
    <Flex flexDirection="column">
      <Flex
        flexDirection="column"
        align="center"
        justify="center"
        gap={16}
        p={{ pb: 16, px: 16, pt: isPaymentFeatureEnabled ? 32 : undefined }}
        md={{ p: { px: 24 } }}
        d={{ p: { px: 32 } }}
      >
        {isPaymentFeatureEnabled && <PaymentFeature {...props} />}

        <FooterLogoAndLanguageSelect
          data={data}
          getUrl={getUrl}
          onCallAction={onCallAction}
          isActionInactive={isActionInactive}
        />

        <FooterMenu
          data={data}
          getUrl={getUrl}
          onCallAction={onCallAction}
          isActionInactive={isActionInactive}
        />

        <BottomLogos
          data={data}
          getUrl={getUrl}
          onCallAction={onCallAction}
          isActionInactive={isActionInactive}
        />
      </Flex>

      <FooterBottomButtons
        data={data}
        getUrl={getUrl}
        onCallAction={onCallAction}
        isActionInactive={isActionInactive}
      />

      <FooterDescription
        data={data}
        getUrl={getUrl}
        onCallAction={onCallAction}
        isActionInactive={isActionInactive}
      />
    </Flex>
  );
};
